export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["media/branding/facebook/facebook-250x250.png","media/branding/facebook/facebook-500x500.png","media/branding/facebook/facebook-500x500.ppm","media/branding/instagram/instagram-100x100.png","media/branding/instagram/instagram-250x250.png","media/branding/instagram/instagram-500x500.png","media/branding/instagram/instagram-full-resolution.png","media/branding/officialartisanfair/logo-green-100x100.webp","media/branding/officialartisanfair/logo-green-250x250.webp","media/branding/officialartisanfair/logo-green-500x500.webp","media/branding/officialartisanfair/logo-green-full.png","media/branding/officialartisanfair/logo-green-full.webp","media/branding/officialartisanfair/logo-transparent.png","media/branding/officialartisanfair/logo-transparent.webp","media/flyers/dogadoption-2025-12-28.webp","media/flyers/night-2025-12-05.webp","media/flyers/night-2025-12-19.webp","media/flyers/night-2026-01-02.webp","media/flyers/riverwalk-2025-11-09.webp","media/flyers/riverwalk-2026-01-04.webp","media/flyers/rosedale-2026-01-03.webp"]),
	mimeTypes: {".png":"image/png",".webp":"image/webp"},
	_: {
		client: {start:"_app/immutable/entry/start.XNKp_HcN.js",app:"_app/immutable/entry/app.CAUBaLd8.js",imports:["_app/immutable/entry/start.XNKp_HcN.js","_app/immutable/chunks/SjIGePN-.js","_app/immutable/chunks/DXK7xvw7.js","_app/immutable/chunks/CtZl-tYg.js","_app/immutable/entry/app.CAUBaLd8.js","_app/immutable/chunks/CtZl-tYg.js","_app/immutable/chunks/CWj6FrbW.js","_app/immutable/chunks/DXK7xvw7.js","_app/immutable/chunks/LOhPtrgM.js","_app/immutable/chunks/Dh2UqRCn.js"],stylesheets:[],fonts:[],uses_env_dynamic_public:false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/3.js'))
		],
		routes: [
			{
				id: "/events",
				pattern: /^\/events\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 2 },
				endpoint: null
			}
		],
		prerendered_routes: new Set(["/"]),
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set(["/"]);

export const base = "";